/**
 * game-gangqin.js —— 学习乐园 · 琴谱跟弹（虚拟琴键 + 星星掉落 + 等待判定）
 * ---------------------------------------------------------------------------
 * 四种玩法：demo 演奏给你看（星星按拍落，到线自动弹）/ practice 等待判定
 * （星星停在线上等你按对才走，连错 3 次跳过并明说）/ free 自由弹（无判定）/
 * score 跟谱练（动态电子谱：谱面按拍推进、当前音高亮、不出声，配可关节拍器，
 * 给对着真琴练的人——星星不掉不打分，屏幕就是一份会自己翻的乐谱）。
 * 音源：WebAudio 现场合成（基频+泛音+低通+包络），无采样文件、零网络请求。
 *   如实边界：合成的是「能听出音高」的琴声，不是真钢琴音色，页面上不夸大。
 * 纪律：零网络请求；成绩只存本机 localStorage；动态内容一律 textContent；
 *   jsdom 兼容：无 AudioContext 静音可玩、canvas 缺失判定照常、pressNote 绑 click。
 */
(function (global) {
  'use strict';
  var doc = global.document;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var UI = global.ST_UI || {};

  function el(tag, cls) { var n = doc.createElement(tag); if (cls) { n.className = cls; } return n; }
  function span(cls, text) { var n = el('span', cls); n.textContent = text; return n; }
  function icon(name) {
    var svg = doc.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'tool-icon'); svg.setAttribute('aria-hidden', 'true');
    var use = doc.createElementNS(SVG_NS, 'use'); use.setAttribute('href', '#i-' + name);
    svg.appendChild(use); return svg;
  }
  function setText(node, s) { if (node && node.textContent !== s) { node.textContent = s; } }

  var root = doc.querySelector('[data-st-gangqin]');
  var E = {};

  /* ---------------- 曲库（C 大调 [midi, 拍数]，拍支持 0.5/0.75 附点） ---------------- */
  var SONGS = [
    { id: 'scale', name: 'C 大调音阶', meter: 4, bpm: 96, diff: 1, tip: '上行再下行，第一次摸键盘就从它开始',
      notes: [[60,1],[62,1],[64,1],[65,1],[67,1],[69,1],[71,1],[72,1],[71,1],[69,1],[67,1],[65,1],[64,1],[62,1],[60,1],[60,2]] },
    { id: 'twinkle', name: '小星星', meter: 4, bpm: 100, diff: 1, tip: '六句一闪一闪，句尾拖两拍',
      notes: [[60,1],[60,1],[67,1],[67,1],[69,1],[69,1],[67,2],[65,1],[65,1],[64,1],[64,1],[62,1],[62,1],[60,2],
              [67,1],[67,1],[65,1],[65,1],[64,1],[64,1],[62,2],[67,1],[67,1],[65,1],[65,1],[64,1],[64,1],[62,2],
              [60,1],[60,1],[67,1],[67,1],[69,1],[69,1],[67,2],[65,1],[65,1],[64,1],[64,1],[62,1],[62,1],[60,2]] },
    { id: 'liangzhi', name: '两只老虎', meter: 4, bpm: 112, diff: 1, tip: '整体比唱名高一个八度，末句「一只没有耳朵」落回低音 5',
      notes: [[72,1],[74,1],[76,1],[72,1],[72,1],[74,1],[76,1],[72,1],[76,1],[77,1],[79,2],[76,1],[77,1],[79,2],
              [79,1],[81,1],[79,1],[77,1],[76,1],[72,1],[79,1],[81,1],[79,1],[77,1],[76,1],[72,1],
              [72,1],[67,1],[72,2],[72,1],[67,1],[72,2]] },
    { id: 'huanchuan', name: '划小船', meter: 2, bpm: 120, diff: 2, tip: '前两句是附点节奏：第三个音要拖半拍',
      notes: [[60,1],[60,1],[60,1.5],[62,0.5],[64,2],[64,1.5],[62,0.5],[64,0.5],[65,0.5],[67,2],
              [72,1.5],[72,0.5],[72,0.5],[67,0.5],[67,0.5],[67,0.5],[64,0.5],[64,0.5],[64,0.5],[60,0.5],[60,0.5],[60,0.5],
              [67,1.5],[65,0.5],[64,0.5],[62,0.5],[60,2]] },
    { id: 'ode', name: '欢乐颂', meter: 4, bpm: 112, diff: 2, tip: '四句旋律，3 4 5 挨得紧，别跳键',
      notes: [[64,1],[64,1],[65,1],[67,1],[67,1],[65,1],[64,1],[62,1],[60,1],[60,1],[62,1],[64,1],[64,1.5],[62,0.5],[62,2],
              [64,1],[64,1],[65,1],[67,1],[67,1],[65,1],[64,1],[62,1],[60,1],[60,1],[62,1],[64,1],[62,1.5],[60,0.5],[60,2],
              [62,1],[62,1],[64,1],[60,1],[62,1],[64,1],[65,1],[64,1],[60,1],[62,1],[64,1],[65,1],[64,1],[62,1],[60,1],[67,2],
              [64,1],[64,1],[65,1],[67,1],[67,1],[65,1],[64,1],[62,1],[60,1],[60,1],[62,1],[64,1],[62,1.5],[60,0.5],[60,2]] },
    { id: 'shengri', name: '生日快乐', meter: 3, bpm: 100, diff: 3, tip: '三拍子加附点，「祝你」两个字是短长关系',
      notes: [[67,0.75],[67,0.25],[69,1],[67,1],[72,1],[71,2],[67,0.75],[67,0.25],[69,1],[67,1],[74,1],[72,2],
              [67,0.75],[67,0.25],[79,1],[76,1],[72,1],[71,1],[69,1],[77,1.5],[77,0.5],[76,1],[72,1],[74,1],[72,2]] }
  ];
  var DIFF_CN = { 1: '入门', 2: '进阶', 3: '挑战' };

  /* ---------------- 键位：25 键 C4(60)~C6(84)。白键 Z X C V B N M + Q W E R T Y U I，
   * 黑键 S D G H J（低八度）+ 2 3 5 6 7（高八度），黑键在白键缝隙上方。 ---------------- */
  var NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
  var BLACK = { 1: 1, 3: 1, 6: 1, 8: 1, 10: 1 };
  var KEY_OF = {
    60:'Z', 61:'S', 62:'X', 63:'D', 64:'C', 65:'V', 66:'G', 67:'B', 68:'H', 69:'N', 70:'J', 71:'M',
    72:'Q', 73:'2', 74:'W', 75:'3', 76:'E', 77:'R', 78:'5', 79:'T', 80:'6', 81:'Y', 82:'7', 83:'U', 84:'I'
  };
  function keyOf(midi) { return KEY_OF[midi] || ''; }
  function noteName(midi) { return NOTE_NAMES[midi % 12] + (Math.floor(midi / 12) - 1); }

  /* ---------------- 音符的形状与颜色（星星 = 一枚真音符） ----------------
   * 颜色按音级走音乐课堂通用的彩虹口径（Boomwhacker）：C 红 D 橙 E 黄 F 绿
   * G 青 A 蓝 B 紫；黑键用同系深色（六首曲子全是自然音，此表备用也保全）。
   * E 系选琥珀深档，白字在明暗两套主题下都可读。 */
  var NOTE_COLORS = {
    0: '#dc2626', 1: '#991b1b', 2: '#ea580c', 3: '#9a3412', 4: '#b45309',
    5: '#16a34a', 6: '#166534', 7: '#0e7490', 8: '#155e75', 9: '#2563eb',
    10: '#1e40af', 11: '#7c3aed'
  };
  function noteColor(midi) { return NOTE_COLORS[midi % 12] || '#6366f1'; }
  /** 拍值 → 记谱形状：0.25 十六分 / 0.5 八分 / 0.75 附点八分 / 1 四分 /
   *  1.5 附点四分 / ≥2 二分 / ≥4 全音符（自定义谱允许写到 8 拍） */
  function beatShape(beats) {
    if (beats >= 4) { return 'whole'; }
    if (beats >= 2) { return 'half'; }
    if (beats >= 1.5) { return 'dot'; }
    if (beats >= 1) { return 'quarter'; }
    if (beats >= 0.75) { return 'dot8'; }
    if (beats >= 0.5) { return 'eighth'; }
    return 'sixteenth';
  }
  /** 迷你音符 glyph（内联 SVG，白描随底色反衬）：符头+符干为基，
   *  八分/附点八分加符尾曲线、附点四分/附点八分加附点、二分/全音符符头空心
   *  （全音符无符干）。 */
  function noteGlyph(shape) {
    var svg = doc.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'st-chip-note');
    svg.setAttribute('viewBox', '0 0 20 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    function add(tag, attrs) {
      var n = doc.createElementNS(SVG_NS, tag);
      for (var k in attrs) { n.setAttribute(k, attrs[k]); }
      svg.appendChild(n);
    }
    var head = { cx: 6.4, cy: 18.6, rx: 4.4, ry: 3.2, transform: 'rotate(-18 6.4 18.6)' };
    if (shape === 'whole') { head.cx = 10; head.transform = 'rotate(-18 10 18.6)'; }
    if (shape === 'half' || shape === 'whole') {
      add('ellipse', Object.assign({}, head, { fill: 'none', stroke: 'currentColor', 'stroke-width': 1.9 }));
    } else {
      add('ellipse', Object.assign({}, head, { fill: 'currentColor' }));
    }
    if (shape !== 'whole') {
      add('rect', { x: 9.9, y: 3.2, width: 1.7, height: 15.4, fill: 'currentColor' });
    }
    if (shape === 'eighth' || shape === 'sixteenth' || shape === 'dot8') {
      add('path', { d: 'M11.6 3.2 C15.6 5.6 15.9 9.4 13.6 12.8 L11.9 11.8 C13.8 8.9 13.6 6.5 10.9 4.8 Z', fill: 'currentColor' });
    }
    if (shape === 'sixteenth') {
      add('path', { d: 'M11.6 8.2 C15.6 10.6 15.9 14.4 13.6 17.8 L11.9 16.8 C13.8 13.9 13.6 11.5 10.9 9.8 Z', fill: 'currentColor' });
    }
    if (shape === 'dot' || shape === 'dot8') {
      add('circle', { cx: 17.4, cy: 18.6, r: 1.7, fill: 'currentColor' });
    }
    return svg;
  }

  /* ---------------- 音源：WebAudio 现场合成 ---------------- */
  var A = {
    ctx: null, master: null,
    ok: function () {
      if (this.ctx) { return true; }
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) { return false; }
      try {
        this.ctx = new AC();
        this.master = this.ctx.createGain();
        this.master.gain.value = 0.5;
        if (this.ctx.createDynamicsCompressor) {
          var comp = this.ctx.createDynamicsCompressor();
          this.master.connect(comp); comp.connect(this.ctx.destination);
        } else { this.master.connect(this.ctx.destination); }
      } catch (e) { this.ctx = null; return false; }
      return true;
    },
    ensure: function (done) {
      if (!this.ok()) { done(false); return; }
      if (this.ctx.state === 'suspended') {
        var p = this.ctx.resume();
        if (p && p.then) { p.then(function () { done(true); }, function () { done(true); }); }
        else { done(true); }
        return;
      }
      done(true);
    },
    note: function (midi, durSec) {
      if (!this.ctx) { return; }
      var ctx = this.ctx, f = 440 * Math.pow(2, (midi - 69) / 12), t = ctx.currentTime;
      var lp = ctx.createBiquadFilter();
      lp.type = 'lowpass'; lp.frequency.value = Math.min(f * 7, 9500); lp.connect(this.master);
      var g = ctx.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(0.9, t + 0.006);
      g.gain.setTargetAtTime(0.28, t + 0.006, 0.18);
      g.gain.setTargetAtTime(0.0001, t + Math.max(0.12, durSec), 0.09);
      g.connect(lp);
      var osc = ctx.createOscillator();
      osc.type = 'triangle'; osc.frequency.value = f;
      osc.connect(g); osc.start(t); osc.stop(t + durSec + 0.9);
      var P = [[2, 0.35], [3, 0.12], [4.01, 0.06]];
      for (var i = 0; i < P.length; i++) {
        var og = ctx.createGain(); og.gain.value = P[i][1]; og.connect(g);
        var oo = ctx.createOscillator();
        oo.type = 'sine'; oo.frequency.value = f * P[i][0];
        oo.connect(og); oo.start(t); oo.stop(t + durSec + 0.9);
      }
    },
    panic: function () { /* 合成音源自会衰减，急停只清调度 */ },
    /* 节拍器 tick：短促正弦嗒声，强拍高一点响一点（C6 / G5），独立于琴声不复用 note */
    tick: function (strong) {
      if (!this.ctx) { return; }
      var ctx = this.ctx, t = ctx.currentTime;
      var g = ctx.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(strong ? 0.55 : 0.3, t + 0.002);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.08);
      g.connect(this.master);
      var o = ctx.createOscillator();
      o.type = 'sine'; o.frequency.value = strong ? 1046 : 784;
      o.connect(g); o.start(t); o.stop(t + 0.1);
    }
  };

  /* ---------------- 运行状态 ---------------- */
  var mode = 'practice';   // demo | practice | free
  var song = SONGS[1];     // 默认小星星
  var customSong = null;   /* 「我的谱子」：本机解析后的曲对象，null = 还没存过 */
  var running = false;
  var chip = null;         // { midi, x, y, el } 命中线上等待的星（practice）
  var queue = [];          // 待落星 [{midi, el, atBeat}]（practice）/ demo 调度复用 timers
  var idx = 0;             // 已判定到的音符下标
  var score = 0, combo = 0, bestCombo = 0, miss = 0, wrongStreak = 0;
  var timers = [];
  var demoRAF = null, hintTimer = null;
  var metroOn = false;     /* 节拍器（跟谱练用）：默认关，偏好存本机 */

  /* ---------------- 存档（只存本机） ---------------- */
  var LS_BEST = 'study-gangqin-best';
  var LS_PREF = 'study-gangqin-pref';
  var LS_CUSTOM = 'study-gangqin-custom';
  function loadBest() {
    try { return JSON.parse(global.localStorage.getItem(LS_BEST)) || {}; }
    catch (e) { return {}; }
  }
  function saveBest(slug, rec) {
    try {
      var all = loadBest(), old = all[slug];
      if (!old || rec.score > old.score || (rec.score === old.score && rec.stars > old.stars)) { all[slug] = rec; }
      global.localStorage.setItem(LS_BEST, JSON.stringify(all));
      renderBest();
    } catch (e) { /* 隐私模式：不保存也能玩 */ }
  }
  function savePref() {
    try { global.localStorage.setItem(LS_PREF, JSON.stringify({ song: song.id, mode: mode, fx: fx, metro: metroOn })); } catch (e) { /* 同上 */ }
  }
  function loadPref() {
    try { return JSON.parse(global.localStorage.getItem(LS_PREF)) || null; } catch (e) { return null; }
  }
  function renderBest() {
    if (!E.best) { return; }
    var b = loadBest()[song.id];
    setText(E.best, b
      ? '这首的最好成绩：' + b.stars + ' 星 · ' + b.score + ' 分（连对 ' + b.combo + '）'
      : '这首还没有成绩，弹完一局就有记录（只存这台设备）。');
  }

  /* ---------------- 曲库与键盘渲染 ---------------- */
  function renderSongs() {
    if (!E.songsBox) { return; }
    E.songsBox.textContent = '';
    SONGS.forEach(function (s) {
      var b = el('button', 'st-song-btn');
      b.type = 'button';
      b.setAttribute('data-st-song', s.id);
      b.appendChild(span('st-song-name', s.name));
      b.appendChild(span('st-song-diff st-song-diff--' + s.diff, DIFF_CN[s.diff]));
      b.addEventListener('click', function () { pickSong(s.id); });
      E.songsBox.appendChild(b);
    });
    /* 「我的谱子」固定在曲单末尾：选了它出现编辑面板，没有存过就是空壳；
       导入过 MusicXML 的显示曲名。--custom 修饰类是品牌渐变实底入口
       （功能入口权重高于曲库胶囊，与 .st-song-btn--custom 样式一致），
       空壳带「+」前缀表明「从这里创建」 */
    var c = el('button', 'st-song-btn st-song-btn--custom');
    c.type = 'button';
    c.setAttribute('data-st-song', 'custom');
    c.appendChild(span('st-song-name', (customSong && customSong.name) || '+ 我的谱子'));
    c.appendChild(span('st-song-diff st-song-diff--2', 'DIY'));
    c.addEventListener('click', function () { pickSong('custom'); });
    E.songsBox.appendChild(c);
    syncSongs();
  }
  function syncSongs() {
    var btns = E.songsBox ? E.songsBox.querySelectorAll('[data-st-song]') : [];
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-st-song') === song.id;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  function pickSong(id) {
    var found = null;
    if (id === 'custom') {
      found = customSong || { id: 'custom', name: '我的谱子', meter: 4, bpm: 80, diff: 2,
        tip: '在下面的面板里写谱子，点「保存并跟弹」', notes: [] };
    } else {
      SONGS.forEach(function (s) { if (s.id === id) { found = s; } });
    }
    if (!found) { return; }
    song = found;
    if (E.customPanel) { E.customPanel.hidden = song.id !== 'custom'; }
    syncSongs();
    renderBest();
    savePref();
    if (running) { stopRun(true); }
    if (mode !== 'free') { sheetBuild(); sheetFollow(0); }
    /* 出版谱跟着换曲：清缓存键，面板开着就立即重渲（导入后直接看出谱的关键路径） */
    osmdKey = '';
    if (E.osmd && !E.osmd.hidden) { syncOsmdSource(); renderOsmd(); }
    setText(E.status, '选了《' + song.name + '》。' + song.tip + ' 点「开始」来一局。');
  }
  /* ---------------- 自定义谱（我的谱子）：本机保存、零上传 ----------------
   * 格式对练琴的人最好懂：音名+八度（C4 / F#4 / Bb3），/2 拖两拍（0.25~8，
   * 0.25 步进），- 延音一拍；空格逗号换行都能分隔。只收 25 键（C4~C6），
   * 写错报到第几个 token，不弹窗。 */
  var PC_OF_LETTER = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
  function parseCustom(text) {
    var tokens = String(text || '').trim().split(/[\s,;，；、]+/).filter(Boolean);
    if (!tokens.length) { return { err: '还没写谱子——照例句写：C4 C4 G4 G4 A4 A4 G4/2' }; }
    if (tokens.length > 300) { return { err: '最多 300 个音，太长了拆成两段吧' }; }
    var notes = [];
    for (var i = 0; i < tokens.length; i++) {
      var tk = tokens[i].toUpperCase();
      var beats = 1;
      var slash = tk.indexOf('/');
      if (slash >= 0) {
        var bv = Math.round(parseFloat(tk.slice(slash + 1)) * 4) / 4;
        if (!(bv >= 0.25 && bv <= 8)) { return { err: '第 ' + (i + 1) + ' 个「' + tokens[i] + '」拍数要写在 0.25~8 之间' }; }
        beats = bv;
        tk = tk.slice(0, slash);
      }
      if (tk === '-') {
        if (!notes.length) { return { err: '第 1 个就是「-」——延音线前面得先有一个音' }; }
        notes[notes.length - 1][1] += beats;
        continue;
      }
      var m = /^([A-G])(#|B)?([1-6])$/.exec(tk);
      if (!m) { return { err: '第 ' + (i + 1) + ' 个「' + tokens[i] + '」看不懂——写成 C4、F#4、Bb3 这样（音名+八度）' }; }
      var midi = (parseInt(m[3], 10) + 1) * 12 + PC_OF_LETTER[m[1]] + (m[2] === '#' ? 1 : (m[2] === 'B' ? -1 : 0));
      if (midi < 60 || midi > 84) { return { err: '第 ' + (i + 1) + ' 个「' + tokens[i] + '」超出键盘——屏幕上只有 C4~C6 这 25 个键' }; }
      /* 第三位存升降拼写（'#'/'b'/null）：响的是 midi，谱上画的记号按原拼写 */
      notes.push([midi, beats, m[2] === '#' ? '#' : (m[2] === 'B' ? 'b' : null)]);
    }
    return { notes: notes };
  }
  function loadCustomRaw() {
    try {
      var d = JSON.parse(global.localStorage.getItem(LS_CUSTOM));
      return d && d.text ? d : null;
    } catch (e) { return null; }
  }
  function customSongOf(d) {
    if (!d) { return null; }
    var r = parseCustom(d.text);
    if (r.err) { return null; }
    return { id: 'custom', name: (d.name && String(d.name).slice(0, 20)) || '我的谱子',
      meter: d.meter === 3 ? 3 : 4, meterTop: d.meterTop || d.meter || 4, meterBottom: d.meterBottom || 4,
      bpm: d.bpm >= 40 && d.bpm <= 200 ? d.bpm : 80, diff: 2,
      tip: '自己的谱子，' + r.notes.length + ' 个音', notes: r.notes };
  }
  /* 曲单上「我的谱子」按钮跟随导入的曲名（空壳态带「+」前缀，与 renderSongs 一致） */
  function syncCustomBtn() {
    if (!E.songsBox) { return; }
    var b = E.songsBox.querySelector('[data-st-song="custom"] .st-song-name');
    if (b) { b.textContent = (customSong && customSong.name) || '+ 我的谱子'; }
  }
  function showCustomErr(msg) {
    if (E.customErr) { E.customErr.textContent = msg; E.customErr.hidden = false; }
  }
  function saveCustom(extraMsg) {
    if (!E.customText) { return; }
    var bpm = parseInt(E.customBpm && E.customBpm.value, 10);
    if (!(bpm >= 40 && bpm <= 200)) { bpm = 80; }
    /* 拍号下拉是唯一事实源：'2' = 2/2（切线按 4 个四分拍走），其余 4/4、3/4 */
    var mv = E.customMeter ? E.customMeter.value : '4';
    var meter = mv === '3' ? 3 : 4;
    var meterTop = mv === '2' ? 2 : meter;
    var meterBottom = mv === '2' ? 2 : 4;
    var r = parseCustom(E.customText.value);
    if (r.err) { showCustomErr(r.err); return; }
    if (E.customErr) { E.customErr.hidden = true; }
    var name = (customSong && customSong.name) || '我的谱子';
    try {
      global.localStorage.setItem(LS_CUSTOM, JSON.stringify({ bpm: bpm, meter: meter, meterTop: meterTop, meterBottom: meterBottom, name: name, text: E.customText.value }));
    } catch (e) { /* 隐私模式：本次会话内仍可用 */ }
    customSong = { id: 'custom', name: name, meter: meter, meterTop: meterTop, meterBottom: meterBottom, bpm: bpm, diff: 2,
      tip: '自己的谱子，' + r.notes.length + ' 个音', notes: r.notes };
    syncCustomBtn();
    pickSong('custom');
    setText(E.status, '存好了：' + r.notes.length + ' 个音、' + bpm + ' 拍/分。点「开始」跟一遍，四种玩法都适用。' + (extraMsg || ''));
  }
  /* ---------------- 导入 MusicXML（MuseScore / Finale 等导出） ----------------
   * 本机解析不上传：取第一个声部（遇 backup 停，多声部只拿主旋律），和弦取
   * 最高音、连线(tie)并入前音、休止并成延音、装饰音跳过；divisions/速度/
   * 拍号/曲名一并读出来。超出 25 键的先尝试整体移八度，仍越界的夹到 C4/C6。
   * 结果转成音名序列填进面板——用户能直接看懂、改完再保存。 */
  function beatsRound(v) { return Math.round(v * 4) / 4; }
  /** midi+拼写 → 面板 token：降号按原拼写写 Bb（而非 A#），升号/自然音用标准名 */
  function midiToken(m, beats, acc) {
    var name = acc === 'b' ? NOTE_NAMES[(m % 12 + 1) % 12] + 'b' : NOTE_NAMES[m % 12];
    var t = name + (Math.floor(m / 12) - 1);
    if (beats !== 1) { t += '/' + (beats % 1 ? String(beats) : String(Math.round(beats))); }
    return t;
  }
  function fitToKeys(midis, accs) {
    var shift = 0, bestOut = Infinity;
    [-24, -12, 0, 12, 24].forEach(function (s) {
      var out = 0;
      midis.forEach(function (m) { var v = m + s; if (v < 60 || v > 84) { out++; } });
      if (out < bestOut) { bestOut = out; shift = s; }
    });
    var clamped = 0;
    var fixed = midis.map(function (m) {
      var v = m + shift;
      if (v < 60) { v = 60; clamped++; } else if (v > 84) { v = 84; clamped++; }
      return v;
    });
    /* 被夹到 C4/C6 的音已是自然音，拼写清掉；其余保留（整体移八度不改变级内关系） */
    var fixedAccs = accs.map(function (a, i) {
      var v = midis[i] + shift;
      return (v < 60 || v > 84) ? null : a;
    });
    return { shift: shift, clamped: clamped, midis: fixed, accs: fixedAccs };
  }
  function parseMusicXml(text) {
    var d = null;
    try { d = new global.DOMParser().parseFromString(String(text), 'application/xml'); } catch (e) { d = null; }
    if (!d || d.querySelector('parsererror')) { return { err: '不是合法的 MusicXML——从 MuseScore「文件 → 导出」选 MusicXML 再试试' }; }
    var part = d.querySelector('part');
    if (!part) { return { err: '文件里没有乐谱内容（找不到 part）' }; }
    var name = '';
    var wt = d.querySelector('work > work-title') || d.querySelector('movement-title');
    if (wt && wt.textContent) { name = wt.textContent.trim().slice(0, 20); }
    /* 拍号读真实数值：meter 恒为「四分拍/小节」（切小节线用），meterTop/meterBottom
       才是谱面显示——2/2 切线 4 拍、显示 2/2；其他底数先回落 4/几（6/8 罕见，不为此铺路） */
    var meter = 4, meterTop = 4, meterBottom = 4;
    var tmEl = d.querySelector('time');
    if (tmEl) {
      var bv = parseInt((tmEl.querySelector('beats') || {}).textContent || '4', 10);
      var bt = parseInt((tmEl.querySelector('beat-type') || {}).textContent || '4', 10);
      if (bv === 2 && bt === 2) { meter = 4; meterTop = 2; meterBottom = 2; }
      else if (bv === 2 || bv === 3 || bv === 4) { meter = bv; meterTop = bv; }
    }
    var bpm = 0;
    var snd = part.querySelector('sound[tempo]');
    if (snd) { var t = parseFloat(snd.getAttribute('tempo')); if (t >= 40 && t <= 200) { bpm = Math.round(t); } }
    var divisions = 0;
    var midis = [], beatsList = [], accList = [];
    var measures = part.querySelectorAll('measure');
    for (var mi = 0; mi < measures.length && midis.length < 300; mi++) {
      var dv = measures[mi].querySelector('divisions');
      if (dv) { divisions = parseInt(dv.textContent, 10) || divisions; }
      var ch = measures[mi].children;
      for (var ci = 0; ci < ch.length; ci++) {
        var node = ch[ci];
        if (node.tagName === 'backup') { break; } /* 第一声部到此为止 */
        if (node.tagName !== 'note') { continue; }
        if (node.querySelector('grace')) { continue; }
        var dur = node.querySelector('duration');
        var b = divisions > 0 && dur ? beatsRound(parseInt(dur.textContent, 10) / divisions) : 1;
        if (b < 0.25) { b = 0.25; } else if (b > 8) { b = 8; }
        var isTieStop = !!(node.querySelector('tie[type="stop"]') || node.querySelector('tied[type="stop"]'));
        if (isTieStop && midis.length) { beatsList[beatsList.length - 1] += b; continue; }
        if (node.querySelector('rest')) {
          if (midis.length) { beatsList[beatsList.length - 1] += b; } /* 休止并成延音 */
          continue;
        }
        var p = node.querySelector('pitch');
        if (!p) { continue; }
        var step = ((p.querySelector('step') || {}).textContent || 'C').trim().toUpperCase();
        var alter = parseInt((p.querySelector('alter') || {}).textContent || '0', 10) || 0;
        var oct = parseInt((p.querySelector('octave') || {}).textContent || '4', 10);
        var midi = (oct + 1) * 12 + (PC_OF_LETTER[step] || 0) + alter;
        var acc = alter > 0 ? '#' : (alter < 0 ? 'b' : null);
        if (node.querySelector('chord') && midis.length) { /* 和弦：取最高音、时值取大 */
          if (midi > midis[midis.length - 1]) { midis[midis.length - 1] = midi; accList[accList.length - 1] = acc; }
          if (b > beatsList[beatsList.length - 1]) { beatsList[beatsList.length - 1] = b; }
          continue;
        }
        midis.push(midi);
        beatsList.push(b);
        accList.push(acc);
      }
    }
    if (!midis.length) { return { err: '没读出旋律线——这份谱子可能只有和弦记号或全是休止符' }; }
    var fit = fitToKeys(midis, accList);
    var tokens = [];
    for (var i = 0; i < fit.midis.length; i++) { tokens.push(midiToken(fit.midis[i], beatsList[i], fit.accs[i])); }
    return { name: name, bpm: bpm || 80, meter: meter, meterTop: meterTop, meterBottom: meterBottom, text: tokens.join(' '),
      count: fit.midis.length, shift: fit.shift, clamped: fit.clamped };
  }
  function importMusicXml(text) {
    var r = parseMusicXml(text);
    if (r.err) { showCustomErr(r.err); return; }
    if (E.customErr) { E.customErr.hidden = true; }
    /* 换上新曲名（saveCustom 从 customSong.name 取名字，先放个名字壳） */
    customSong = { name: r.name || '我的谱子' };
    /* 原稿留下（仅本机内存，不进 localStorage）：出版谱按原稿渲染——双谱表/歌词/
       调号这些出版信息只有原稿有，token 序列装不下；刷新后重导一次即可 */
    customXml = String(text || '');
    E.customText.value = r.text;
    if (E.customBpm) { E.customBpm.value = String(r.bpm); }
    /* 下拉按「显示拍号」回设：2/2 落 '2'，其余回落分子（2/4 等罕见组合暂无选项） */
    if (E.customMeter) {
      E.customMeter.value = (r.meterTop === 2 && r.meterBottom === 2) ? '2' : String(r.meterTop || r.meter);
    }
    var extra = r.name ? '《' + r.name + '》' : '这首曲子';
    if (r.shift) { extra += '（已整体移八度贴到键盘上）'; }
    if (r.clamped) { extra += '，' + r.clamped + ' 个音超出键盘被夹到 C4/C6'; }
    saveCustom('（从 ' + extra + ' 导入，' + r.count + ' 个音，可在上面手改）');
  }

  /* ---------------- 出版谱（OSMD 渲染出版级五线谱） ----------------
   * 「出版谱」面板与跟弹玩法完全独立：跟弹仍走上面的轻量谱（星星/判定/平移
   * 都靠它），这里只管"看"——出版级符杠、符尾、附点、小节结构由 OSMD 出。
   * 数据两条路：
   *   内置曲/手输谱 → buildMusicXml() 运行时生成 MusicXML（单谱表，无网络请求）；
   *   导入 MusicXML → customXml 留了原稿 → 直接喂 OSMD，双谱表/歌词/调号全出。
   * vendor/osmd.min.js（1.3MB）懒注入：第一次展开面板才加载，不进首屏、不进
   * 构建管线；jsdom 无脚本环境注入不生效，面板停留加载文案，零崩溃。 */
  var customXml = '';   /* 导入的 MusicXML 原稿（仅本机内存；换导入覆盖，刷新即失） */
  function xmlEsc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /** midi+拼写 → MusicXML 音位：与 sheetBuild 同一套拼写规则（♭ 右邻白键、♯ 左邻） */
  function xmlSpell(midi, acc) {
    var pc = midi % 12, oct = Math.floor(midi / 12) - 1, deg, alter = 0;
    if (acc === '#') { deg = (pc + 11) % 12; if (pc === 0) { oct -= 1; } alter = 1; }
    else if (acc === 'b') { deg = (pc + 1) % 12; if (pc === 11) { oct += 1; } alter = -1; }
    else { deg = pc; }
    return { step: 'CCDDEFFGGAAB'.charAt(deg), alter: alter, octave: oct };
  }
  /** 四分拍数 → 符型+附点：0.75=附点八分、1.5=附点四分、3=附点二分（token 是 0.25 粒度） */
  function xmlNoteType(beats) {
    var T = { '0.25': ['16th', 0], '0.5': ['eighth', 0], '0.75': ['eighth', 1], '1': ['quarter', 0],
      '1.5': ['quarter', 1], '2': ['half', 0], '3': ['half', 1], '4': ['whole', 0] };
    return T[String(beats)] || ['quarter', 0];  /* 非标时值按四分占位，duration 照写（OSMD 能出谱） */
  }
  /** song.notes → 单谱表 MusicXML：按拍号切小节，跨小节长音拆 tie（MusicXML 不许音跨小节线） */
  function buildMusicXml(s) {
    if (!s || !s.notes || !s.notes.length) { return ''; }
    var perBar = s.meter || 4;
    var top = s.meterTop || perBar, bottom = s.meterBottom || 4;
    var bpm = s.bpm || 80;
    var measures = [], cur = [], used = 0;
    for (var i = 0; i < s.notes.length; i++) {
      var midi = s.notes[i][0], beats = s.notes[i][1], acc = s.notes[i][2] || '';
      var remain = beats, first = true;
      while (remain > 1e-6) {
        var room = perBar - used;
        if (room < 1e-6) { measures.push(cur); cur = []; used = 0; room = perBar; }
        var take = Math.min(remain, room);
        cur.push({ midi: midi, beats: take, acc: acc, tieStart: remain - take > 1e-6, tieStop: !first });
        used += take; remain -= take; first = false;
      }
    }
    if (cur.length) { measures.push(cur); }
    var out = ['<?xml version="1.0" encoding="UTF-8"?>',
      '<score-partwise version="3.1">',
      '<work><work-title>' + xmlEsc(s.name || '未命名') + '</work-title></work>',
      '<part-list><score-part id="P1"><part-name>旋律</part-name></score-part></part-list>',
      '<part id="P1">'];
    for (var mi = 0; mi < measures.length; mi++) {
      out.push('<measure number="' + (mi + 1) + '">');
      if (mi === 0) {
        out.push('<attributes><divisions>4</divisions><key><fifths>0</fifths></key>' +
          '<time><beats>' + top + '</beats><beat-type>' + bottom + '</beat-type></time>' +
          '<clef><sign>G</sign><line>2</line></clef></attributes>',
          '<direction placement="above"><direction-type><metronome><beat-unit>quarter</beat-unit>' +
          '<per-minute>' + bpm + '</per-minute></metronome></direction-type>' +
          '<sound tempo="' + bpm + '"/></direction>');
      }
      for (var ni = 0; ni < measures[mi].length; ni++) {
        var p = measures[mi][ni], sp = xmlSpell(p.midi, p.acc), nt = xmlNoteType(p.beats);
        var n = '<note><pitch><step>' + sp.step + '</step>';
        if (sp.alter) { n += '<alter>' + sp.alter + '</alter>'; }
        n += '<octave>' + sp.octave + '</octave></pitch><duration>' + Math.round(p.beats * 4) + '</duration>';
        if (p.tieStop) { n += '<tie type="stop"/>'; }
        if (p.tieStart) { n += '<tie type="start"/>'; }
        n += '<voice>1</voice><type>' + nt[0] + '</type>';
        for (var d = 0; d < nt[1]; d++) { n += '<dot/>'; }
        if (p.acc === '#') { n += '<accidental>sharp</accidental>'; }
        else if (p.acc === 'b') { n += '<accidental>flat</accidental>'; }
        if (p.tieStop || p.tieStart) {
          n += '<notations>';
          if (p.tieStop) { n += '<tied type="stop"/>'; }
          if (p.tieStart) { n += '<tied type="start"/>'; }
          n += '</notations>';
        }
        out.push(n + '</note>');
      }
      out.push('</measure>');
    }
    out.push('</part></score-partwise>');
    return out.join('');
  }
  /* —— 面板：懒注入 OSMD（同 confetti 口径），展开即渲当前曲，同曲不重渲 —— */
  var osmdReady = false, osmdPending = false, osmdObj = null;
  var osmdKey = '';     /* 已渲染曲子标识：选曲/保存/导入都会清零强制重渲 */
  var osmdZoom = 0.8;
  /** 剥掉原稿按 A4 排版的强制换行/分页指令（print new-system/new-page）：
      OSMD Endless 本来就按面板宽自动折行（pageWidth=容器宽/zoom/10），
      留着原稿 breaks 会让每行没铺满就被掐断——横向滚动时看到「五线断了、
      行尾大片空白」，剥掉后 OSMD 全自动排版，每行铺满、纵向长卷。
      print 可能自闭合，也可能带 system-layout 子元素——必须整元素剥，
      只剥开标签会留下孤儿 </print> 直接毁掉整份 XML */
  function osmdStripBreaks(xml) {
    return String(xml || '').replace(
      /<print\b(?=[^>]*\bnew-(?:system|page)="yes")[^>]*?(?:\/>|>[\s\S]*?<\/print>)/g, ''
    );
  }
  function osmdCtor() {
    var lib = global.opensheetmusicdisplay;
    return lib && typeof lib.OpenSheetMusicDisplay === 'function' ? lib.OpenSheetMusicDisplay : null;
  }
  function ensureOsmd() {
    if (osmdReady) { return true; }
    if (osmdPending) { return false; }
    osmdPending = true;
    if (E.osmd) { E.osmd.textContent = '出版谱引擎加载中（约 1.3MB，只在第一次展开时加载）……'; }
    var s = doc.createElement('script');
    s.src = '/static/study/vendor/osmd.min.js?v=' + (root.getAttribute('data-st-ver') || '');
    s.async = true;
    s.onload = function () {
      osmdPending = false;
      osmdReady = !!osmdCtor();
      if (osmdReady) { renderOsmd(); }
      else if (E.osmd) { E.osmd.textContent = '出版谱引擎没加载完整——刷新页面再试一次。'; }
    };
    s.onerror = function () {
      osmdPending = false;
      if (E.osmd) { E.osmd.textContent = '出版谱引擎没加载出来——网络异常或刷新重试。'; }
    };
    doc.head.appendChild(s);
    return false;
  }
  function renderOsmd() {
    if (!osmdReady || !E.osmd || E.osmd.hidden) { return; }
    /* OSMD 量字宽要 canvas 2d（VexFlow 依赖）：jsdom/精简 WebView 没有——
       与其 render 半路崩，不如提前说明；跟弹玩法全 DOM 绘制，不受影响 */
    if (!canvasOk()) {
      E.osmd.textContent = '这个浏览环境不支持出版谱渲染（缺 canvas）——跟弹玩法不受影响。';
      return;
    }
    if (osmdKey === song.id) { return; }
    var xml = (song.id === 'custom' && customXml) ? osmdStripBreaks(customXml) : buildMusicXml(song);
    osmdKey = song.id;
    if (!xml) {
      E.osmd.textContent = '这首还没有谱面内容——先在「我的谱子」里写几个音，点「保存并跟弹」再来看。';
      return;
    }
    var ctor = osmdCtor();
    if (!ctor) { return; }
    E.osmd.textContent = '正在渲染出版谱……';
    try {
      if (!osmdObj) {
        osmdObj = new ctor(E.osmd, { backend: 'svg', autoResize: true, spacingFactor: 0.85 });
      }
      osmdObj.load(xml).then(function () {
        if (!osmdObj) { return; }
        E.osmd.textContent = '';   /* 清掉「正在渲染」文案：OSMD render 只管自己的 svg，不清容器里的文本节点 */
        osmdObj.zoom = osmdZoom;
        osmdObj.render();   /* 2.1.3 的 load() 之后不会自动出图，必须显式 render */
      }).catch(function (e) {
        E.osmd.textContent = '这份谱子渲染不出来（' + ((e && e.message) || '格式不标准') + '）——换一份标准 MusicXML 试试。';
      });
    } catch (e) {
      E.osmd.textContent = '这份谱子渲染不出来（' + ((e && e.message) || '格式不标准') + '）——换一份标准 MusicXML 试试。';
    }
  }
  function syncOsmdSource() {
    /* 来源标注：导入原稿 vs 由音名生成——两者长得完全不同，用户得知道看的是哪份 */
    if (E.osmdTip) {
      E.osmdTip.textContent = (song.id === 'custom' && customXml)
        ? '出版谱按你导入的 MusicXML 原稿渲染（双谱表、歌词、调号都在）；跟弹用的音名序列是它的主旋律近似。'
        : '出版级五线谱：内置曲由音名序列生成，导入 MusicXML 后按原稿渲染（双谱表、歌词都在）；首次展开约加载 1.3MB。';
    }
  }
  function setOsmdZoom(dz) {
    osmdZoom = Math.max(0.4, Math.min(1.6, Math.round((osmdZoom + dz) * 10) / 10));
    if (E.osmdZoomVal) { E.osmdZoomVal.textContent = Math.round(osmdZoom * 100) + '%'; }
    if (osmdObj && osmdReady && !E.osmd.hidden) { osmdObj.zoom = osmdZoom; osmdObj.render(); }
  }
  function openOsmd() {
    if (!E.osmd) { return; }
    E.osmd.hidden = false;
    if (E.osmdToggle) { E.osmdToggle.setAttribute('aria-expanded', 'true'); }
    if (E.osmdZoomBox) { E.osmdZoomBox.hidden = false; }
    if (E.osmdZoomVal) { E.osmdZoomVal.textContent = Math.round(osmdZoom * 100) + '%'; }
    syncOsmdSource();
    if (!ensureOsmd()) { return; }   /* 引擎就位后 onload 会调 renderOsmd */
    renderOsmd();
  }
  function closeOsmd() {
    if (!E.osmd) { return; }
    E.osmd.hidden = true;
    if (E.osmdToggle) { E.osmdToggle.setAttribute('aria-expanded', 'false'); }
    if (E.osmdZoomBox) { E.osmdZoomBox.hidden = true; }
  }
  function renderKeys() {
    if (!E.keys) { return; }
    E.keys.textContent = '';
    var whites = [];
    for (var m = 60; m <= 84; m++) { if (!BLACK[m % 12]) { whites.push(m); } }
    whites.forEach(function (m) {
      var k = el('button', 'st-pk st-pk--w');
      k.type = 'button';
      k.setAttribute('data-pk', String(m));
      k.setAttribute('aria-label', noteName(m) + '（键盘 ' + keyOf(m) + '）');
      k.appendChild(span('st-pk-name', noteName(m)));
      k.appendChild(span('st-pk-key', keyOf(m)));
      E.keys.appendChild(k);
    });
    /* 黑键 absolute 定位在白键缝隙：左边界 = 之前白键个数 / 总白键数 × 100% */
    var wCount = whites.length;
    var before = 0;
    for (var m2 = 60; m2 <= 84; m2++) {
      if (BLACK[m2 % 12]) {
        var k2 = el('button', 'st-pk st-pk--b');
        k2.type = 'button';
        k2.setAttribute('data-pk', String(m2));
        k2.setAttribute('aria-label', noteName(m2) + '（键盘 ' + keyOf(m2) + '）');
        k2.style.left = 'calc(' + (before / wCount * 100) + '% - var(--st-bkw) / 2)';
        k2.appendChild(span('st-pk-key', keyOf(m2)));
        E.keys.appendChild(k2);
      } else { before++; }
    }
    syncKeys();
  }
  function keyEl(midi) { return E.keys ? E.keys.querySelector('[data-pk="' + midi + '"]') : null; }

  function syncKeys() {
    var btns = E.keys ? E.keys.querySelectorAll('.st-pk') : [];
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.remove('is-down', 'is-wrong', 'is-target');
    }
  }
  /** 键位闪烁：down 按下态（demo 自动弹 / 用户按下共用），280ms 后自动复位 */
  var flashTimers = {};
  function flashKey(midi, cls) {
    var k = keyEl(midi);
    if (!k) { return; }
    k.classList.add(cls || 'is-down');
    var id = midi + (cls || '');
    if (flashTimers[id]) { global.clearTimeout(flashTimers[id]); }
    flashTimers[id] = global.setTimeout(function () {
      k.classList.remove(cls || 'is-down');
      delete flashTimers[id];
    }, 280);
  }
  function pressNote(midi) {
    A.ensure(function () { A.note(midi, 0.45); });
    flashKey(midi, 'is-down');
    if (running && mode === 'practice' && chip) { judge(midi); }
  }

  /* ---------------- 状态行 / HUD ---------------- */
  function updateHud() {
    if (E.hudScore) {
      setText(E.hudScore, String(score));
      E.hudScore.classList.toggle('is-hot', score > 0);
    }
    if (E.hudCombo) {
      setText(E.hudCombo, combo > 0 ? '×' + combo : '—');
      E.hudCombo.classList.toggle('is-hot', combo > 0);
    }
  }
  function updateStatus() {
    if (!E.status) { return; }
    if (!running) { return; }
    if (mode === 'practice') {
      if (chip) {
        setText(E.status, '第 ' + (idx + 1) + ' / ' + song.notes.length + ' 个音：'
          + noteName(chip.midi) + '（键盘 ' + keyOf(chip.midi) + '）');
      } else {
        setText(E.status, '第 ' + idx + ' / ' + song.notes.length + ' 个音');
      }
    }
  }
  function idleStatus() {
    setText(E.status, '选好曲子和玩法，点「开始」。自由弹不用开始，直接按琴键。');
  }

  /* ---------------- 判定（practice）：对→下一位；错→提示；连错 3 次跳过 ---------------- */
  function judge(midi) {
    if (!chip) { return; }
    if (midi === chip.midi) {
      score += 10 + Math.min(combo, 10);
      combo += 1;
      if (combo > bestCombo) { bestCombo = combo; }
      wrongStreak = 0;
      var done = chip.el;
      done.style.transitionDuration = ''; /* 清落下时的内联时长，判定动画回 transition:none */
      done.classList.add('is-hit');
      burst(chip.x);
      /* 留 360ms 让爆闪动画播完再清理 DOM */
      global.setTimeout(function () { if (done.parentNode) { done.parentNode.removeChild(done); } }, 360);
      chip = null;
      advance();
    } else {
      combo = 0;
      wrongStreak += 1;
      flashKey(midi, 'is-wrong');
      if (wrongStreak >= 3) {
        miss += 1;
        wrongStreak = 0;
        var skipped = chip.el;
        skipped.style.transitionDuration = '';
        skipped.classList.add('is-miss');
        global.setTimeout(function () { if (skipped.parentNode) { skipped.parentNode.removeChild(skipped); } }, 420);
        chip = null;
        advance();
        /* 安抚句与去向同屏：跳过提示拼在推进后的「第 N / M 个音」前面（结算分支不拼） */
        if (running && E.status) { setText(E.status, '没关系，跳过它。' + E.status.textContent); }
      } else {
        setText(E.status, '不对哦，星星要的是 ' + noteName(chip.midi) + '（键盘 '
          + keyOf(chip.midi) + '）——再试试。');
        markTarget();
      }
    }
    updateHud();
  }
  function markTarget() {
    syncKeys();
    var k = chip ? keyEl(chip.midi) : null;
    if (k) { k.classList.add('is-target'); }
  }

  /* ---------------- 谱面：掉落区背景的五线谱 ----------------
   * 曲库 [midi, beats] 直接铺成高音谱表（E4 底线，C4 下加一线 ~ C6 上加线，
   * 横轴 = 拍），开头画高音谱号（曲库与自定义谱全部夹在 C4~C6 高音谱表音域
   * 内，低音谱号用不上）+ 拍号；小节线按每首 meter 切分、切点落在长音中间
   * 时跳过。推进时整谱平移让当前音贴住左锚点：已弹变淡、当前音挂音级色
   * 光环——符头颜色与星星同源（noteColor），星星和「它在谱上的原位」一一
   * 对应。内置曲库就是事实源，不引入 MusicXML 解析；黑键曲按拼写画 ♯/♭。
   * 尺寸：掉落区 260px 高装得下，线距 14px（半步 7）、拍宽 42px；音符 glyph
   * 按「线距 10」的单位坐标设计，整组 scale(SCORE_GLYPH) 等比放大——
   * 符头/符干/符尾坐标零改动，加线除外（要在谱面坐标系里对齐谱线）。 */
  var SCORE_BEAT = 42, SCORE_PAD = 78, SCORE_HALF = 7, SCORE_GLYPH = 1.4;
  var sheet = null;   /* { svg, g, notes: [{ el, x }], lw, endX } */
  var sheetCur = 0;   /* sheetFollow 最后指向的音，专注切换重建谱面后要接回去 */
  function sheetClear() {
    if (sheet && sheet.svg && sheet.svg.parentNode) { sheet.svg.parentNode.removeChild(sheet.svg); }
    sheet = null;
  }
  function sheetBuild() {
    sheetClear();
    if (!E.fallWrap || !song.notes || !song.notes.length) { return; }
    var NS = 'http://www.w3.org/2000/svg';
    var focus = doc.body.classList.contains('st-focus-on');
    /* 逻辑坐标系：绘制固定逻辑高、viewBox 等比铺到容器（preserveAspectRatio=none，
       逻辑高 < 容器高时内容被拉伸放大）。
       专注模式横屏/桌面压到 190——谱面主体撑满屏高，线距、音符、
       字号比原来大 ~37%；竖屏（高>宽，手机竖握）保持 260：按高
       缩放已经足够大，再压每屏不到两拍就没法读了。
       普通模式：宽屏（≥768px，桌面/平板横）把逻辑高压到 180，拉伸 ~1.44 倍——
       260 高的容器里五线谱主体原本只占两成，放大后谱线/符头更好认，
       每屏少看 ~两拍（跟弹提前量按锚点比例不变）；再低符头就贴容器边了。
       窄屏保持 1:1，viewBox 本来就比容器宽得多，再压会加剧
       preserveAspectRatio=none 的横向变形。 */
    var wrapH = E.fallWrap.clientHeight || 260;
    var wrapW = E.fallWrap.clientWidth || 600;
    var landscape = wrapW >= wrapH;
    var SH = focus ? (landscape ? 190 : 260) : 260;
    var scale = 1;
    if (focus) {
      scale = Math.max(1, wrapH / SH);
    } else if (wrapW >= 768) {
      SH = 180;
      scale = wrapH / SH;
    }
    var LW = Math.max(600, Math.round(wrapW / scale));
    var SH_eff = Math.max(SH, Math.round(wrapH / scale));
    var cy = Math.round(SH_eff * (focus && landscape ? 0.45 : 0.40));
    function yOf(p) { return cy + (6 - p) * SCORE_HALF; }  /* p: E4=0 半步位，C4=-2 … C6=+12 */
    var svg = doc.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'st-score');
    svg.setAttribute('viewBox', '0 0 ' + LW + ' ' + SH_eff);
    /* 宽高比与容器一致，none 不会变形；统一由 viewBox 负责缩放 */
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var g = doc.createElementNS(NS, 'g');
    g.setAttribute('class', 'st-score-g');
    svg.appendChild(g);
    E.fallWrap.insertBefore(svg, E.fallWrap.firstChild);
    function tag(name, attrs, parent) {
      var n = doc.createElementNS(NS, name);
      for (var k in attrs) { n.setAttribute(k, attrs[k]); }
      (parent || g).appendChild(n);
      return n;
    }
    /* 高音谱号（G 谱号）：简化笔形——竖干（顶钩到底钩）+ 大环，环心交点贴在
       第二线 G4（p=2）上；描边色走 CSS（.st-score-clef），与谱线同灰 */
    var clef = tag('g', { class: 'st-score-clef', transform: 'translate(22 ' + yOf(2) + ')' });
    tag('path', { d: 'M 2.5 -83 C 7 -85 10 -80 8 -75.5 C 4.5 -67 3.5 -57 3.5 -44 C 3.5 -28 4.5 -6 5 8 C 5.4 17 4 25 0 24.5 C -3 24 -4 21.5 -3 19', 'stroke-width': 3, 'stroke-linecap': 'round' }, clef);
    tag('ellipse', { cx: 2, cy: -5, rx: 11.5, ry: 27, transform: 'rotate(-10 2 -5)', 'stroke-width': 3 }, clef);
    var metre = song.meter || 4;
    tag('text', { x: 46, y: cy - 9, class: 'st-score-metre' }).textContent = String(song.meterTop || metre);
    tag('text', { x: 46, y: cy + 21, class: 'st-score-metre' }).textContent = String(song.meterBottom || 4);
    var DEG = [0, 0, 1, 1, 2, 3, 3, 4, 4, 5, 5, 6];  /* pc → C~B 阶名 */
    var items = [];
    var total = 0;
    for (var i = 0; i < song.notes.length; i++) {
      items.push({ midi: song.notes[i][0], beats: song.notes[i][1], acc: song.notes[i][2] || null, start: total });
      total += song.notes[i][1];
    }
    function barX(t) { return SCORE_PAD + t * SCORE_BEAT - 9; }
    /* 五线谱：线长必须盖住「平移全程的可视范围」。viewBox 只到首屏逻辑宽（LW），
       x2 写 100% 就只画到 LW——长谱左滚后线整体跟着左移，当前音右侧还没弹到的
       音符全悬在无线区（用户看到的「音符后面没五条线」）。线直接量到谱尾外
       22（sheetFollow 谱尾贴右缘 -14 再留余量），短谱仍至少铺满首屏；
       超出 viewBox 的部分被 svg overflow hidden 裁掉，不会怼出容器 */
    var lineEnd = Math.max(LW, barX(total) + 22);
    var lineTop = yOf(8);
    for (var li = 0; li < 5; li++) {
      var ly = lineTop + li * SCORE_HALF * 2;
      /* 谱线必须带 class 走 CSS 描边：SVG line 默认 stroke:none，漏了整条五线谱隐形 */
      tag('line', { x1: 0, y1: ly, x2: lineEnd, y2: ly, class: 'st-score-line', 'stroke-width': 1.2 });
    }
    /* 切点落在长音（含换气休止并成的延音）内部：不画实线（小节线不切开音），
       但也不能让小节骨架整个消失——降档成虚线示意边界，露出的小节线仍实线 */
    for (var t = metre; t < total - 1e-6; t += metre) {
      var inside = false;
      for (var w = 0; w < items.length; w++) {
        if (t > items[w].start + 1e-6 && t < items[w].start + items[w].beats - 1e-6) { inside = true; break; }
      }
      if (inside) {
        tag('line', { x1: barX(t), y1: yOf(8) - 6, x2: barX(t), y2: yOf(0) + 6, class: 'st-score-bar', 'stroke-width': 1, 'stroke-dasharray': '2 3', style: 'opacity:.5' });
      } else {
        tag('line', { x1: barX(t), y1: yOf(8) - 6, x2: barX(t), y2: yOf(0) + 6, class: 'st-score-bar', 'stroke-width': 1.2 });
      }
    }
    tag('line', { x1: barX(total), y1: yOf(8) - 6, x2: barX(total), y2: yOf(0) + 6, class: 'st-score-bar', 'stroke-width': 3 });
    var notes = [];
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      var pc = it.midi % 12;
      var black = !!BLACK[pc];
      /* 阶名按拼写走：♭ 取右邻白键（Bb→B），♯ 取左邻（A♯→A），自然音直取——
         响的是 midi，谱上画的是「写谱人眼里的那个音」 */
      var deg = it.acc === 'b' ? DEG[(pc + 1) % 12] : (it.acc === '#' ? DEG[pc - 1] : DEG[pc]);
      var p = (Math.floor(it.midi / 12) - 1) * 7 + deg - 30;
      var x = SCORE_PAD + it.start * SCORE_BEAT;
      var color = noteColor(it.midi);
      var shape = beatShape(it.beats);
      var ng = tag('g', { class: 'st-score-n', transform: 'translate(' + x + ' ' + yOf(p) + ')' });
      /* 加线在谱面坐标系里画（y 用 SCORE_HALF 对齐谱线），不进 glyph 缩放层 */
      if (p <= -2) {
        for (var ld = -2; ld >= p; ld -= 2) {
          tag('line', { x1: -10, y1: (p - ld) * SCORE_HALF, x2: 10, y2: (p - ld) * SCORE_HALF, stroke: color, 'stroke-width': 1.1, opacity: .5 }, ng);
        }
      } else if (p >= 10) {
        for (var lu = 10; lu <= p; lu += 2) {
          tag('line', { x1: -10, y1: (p - lu) * SCORE_HALF, x2: 10, y2: (p - lu) * SCORE_HALF, stroke: color, 'stroke-width': 1.1, opacity: .5 }, ng);
        }
      }
      /* 符头/符干/符尾/附点/♯♭/光环进缩放层：单位坐标整体 × SCORE_GLYPH */
      var inner = tag('g', { transform: 'scale(' + SCORE_GLYPH + ')' }, ng);
      if (black) {
        tag('text', { x: -15, y: 4, class: 'st-score-acc', fill: color }, inner).textContent = it.acc === 'b' ? '♭' : '♯';
      }
      if (shape === 'half' || shape === 'whole') {
        tag('ellipse', { cx: 0, cy: 0, rx: 5.4, ry: 3.9, transform: 'rotate(-18)', fill: 'none', stroke: color, 'stroke-width': 1.8 }, inner);
      } else {
        tag('ellipse', { cx: 0, cy: 0, rx: 5.4, ry: 3.9, transform: 'rotate(-18)', fill: color }, inner);
      }
      if (shape !== 'whole') {
        if (p >= 6) {
          tag('rect', { x: -5.6, y: 0, width: 1.6, height: 30, fill: color }, inner);
        } else {
          tag('rect', { x: 4, y: -30, width: 1.6, height: 30, fill: color }, inner);
        }
      }
      if (shape === 'eighth' || shape === 'sixteenth' || shape === 'dot8') {
        if (p >= 6) {
          tag('path', { d: 'M-4 30 Q4 24 .5 14', fill: 'none', stroke: color, 'stroke-width': 2, 'stroke-linecap': 'round' }, inner);
          if (shape === 'sixteenth') { tag('path', { d: 'M-4 23 Q4 17 .5 7', fill: 'none', stroke: color, 'stroke-width': 2, 'stroke-linecap': 'round' }, inner); }
        } else {
          tag('path', { d: 'M5.6 -29 Q13.6 -23 10.1 -13', fill: 'none', stroke: color, 'stroke-width': 2, 'stroke-linecap': 'round' }, inner);
          if (shape === 'sixteenth') { tag('path', { d: 'M5.6 -22 Q13.6 -16 10.1 -6', fill: 'none', stroke: color, 'stroke-width': 2, 'stroke-linecap': 'round' }, inner); }
        }
      }
      if (shape === 'dot' || shape === 'dot8') { tag('circle', { cx: 9.5, cy: -1.5, r: 1.7, fill: color }, inner); }
      tag('circle', { cx: 0, cy: 0, r: 9.5, fill: 'none', stroke: color, 'stroke-width': 1.6, class: 'st-score-ring' }, inner);
      notes.push({ el: ng, x: x });
    }
    sheet = { svg: svg, g: g, notes: notes, lw: LW, endX: barX(total) + 8 };
  }
  /** 谱面跟随：第 i 个音贴住左锚点（末尾右端贴边即停、短谱整幅不动），
      已弹淡出、当前音亮起（同状态零写入）。
      平移用逻辑单位（viewBox 坐标系），锚点比例随容器缩放一致 */
  function sheetFollow(i) {
    if (!sheet || !sheet.notes[i]) { return; }
    sheetCur = i;
    if (E.focusProg) { E.focusProg.textContent = (i + 1) + '/' + sheet.notes.length; }
    var W = sheet.lw || (E.fallWrap && E.fallWrap.clientWidth) || 600;
    /* 未开始（首音）与整幅放得下的短谱：平移归零，谱面顶左完整展示；
       其余：当前音贴左锚点（18% 预读位），右端贴边即停（末尾收卷，
       不然最后几音也滚到锚点、右侧留白）。
       锚点分支夹上限 0：开头几音还没走到锚点位（x < 锚点）时公式会给正数——
       谱面先往右跳一段再左滚；夹 0 后保持顶左，当前音亮着光环原地等，
       走过锚点位才开始左滚，衔接单调无回跳 */
    var tx = (i === 0 || sheet.endX <= W - 14)
      ? 0
      : Math.min(0, Math.max(Math.max(56, Math.round(W * 0.18)) - sheet.notes[i].x, W - 14 - sheet.endX));
    if (sheet.g.__tx !== tx) { sheet.g.__tx = tx; sheet.g.style.transform = 'translateX(' + tx + 'px)'; }
    for (var k = 0; k < sheet.notes.length; k++) {
      sheet.notes[k].el.classList.toggle('is-done', k < i);
      sheet.notes[k].el.classList.toggle('is-cur', k === i);
    }
  }

  /* ---------------- practice 流程 ---------------- */
  function advance() {
    idx += 1;
    syncKeys();
    if (idx >= song.notes.length) { finishPractice(); return; }
    spawnNext();
    sheetFollow(idx);
    updateStatus();
  }
  /** 下一颗星从顶部落到命中线：间隔 = 该音与下一音的拍差映射成距离（堆叠感） */
  function spawnNext() {
    var n = song.notes[idx][0];
    var c = el('div', 'st-chip');
    /* 星星 = 音符：颜色跟音级、形状跟拍值（本音自己的拍数） */
    c.style.setProperty('--st-note-c', noteColor(n));
    var top = el('div', 'st-chip-top');
    top.appendChild(noteGlyph(beatShape(song.notes[idx][1])));
    top.appendChild(span('st-chip-name', noteName(n)));
    c.appendChild(top);
    c.appendChild(span('st-chip-key', keyOf(n)));
    E.fallWrap.appendChild(c);
    var beatDelta = 1;
    if (idx + 1 < song.notes.length) {
      beatDelta = song.notes[idx + 1][1];
    }
    queue.push({ midi: n, el: c, gap: 10 + Math.min(beatDelta * 26, 72) });
    layoutChips();
    if (!chip) { promote(); }
  }
  /** 队首星落位：CSS transition 把它从顶部移到命中线，到达后成为等待判定的 chip */
  function promote() {
    var head = queue.shift();
    if (!head) { chip = null; updateStatus(); armHint(); return; }
    chip = { midi: head.midi, el: head.el, x: 0, y: 0 };
    dropChip();
    updateStatus();
    markTarget();
    armHint();
  }
  /** 星星水平对准目标琴键的中心：键中心 − 掉落区左缘 − 半个星星宽。
   *  用视口坐标差计算，白键黑键（absolute 缝隙定位）通吃；
   *  无布局环境（jsdom 等宽高全 0）回退居中，与旧版行为一致。 */
  function chipXFor(midi, cw) {
    var k = keyEl(midi);
    if (k && E.fallWrap) {
      var kr = k.getBoundingClientRect();
      var wr = E.fallWrap.getBoundingClientRect();
      if (kr.width > 0 || wr.width > 0) {
        return Math.max(0, kr.left + kr.width / 2 - wr.left - cw / 2);
      }
    }
    return Math.max(0, ((E.fallWrap && E.fallWrap.clientWidth) || 600) - cw) / 2;
  }
  function dropChip() {
    if (!chip) { return; }
    var wrap = E.fallWrap;
    var h = wrap.clientHeight || 260;
    var c = chip.el;
    var cw = c.offsetWidth || 64;
    var tx = chipXFor(chip.midi, cw);
    /* 下落时长随容器高等比（速度恒定，260px 容器 2.4s 的手感基准）：
       容器越高行程越长，等比拉长时长让预读跟着变从容；上限 3.4s
       防超高容器星星飘太久。星星只存在于 practice（无拍子压力）。 */
    var dur = Math.min(3.4, Math.max(1.8, h * 2.4 / 260));
    c.style.transitionDuration = dur.toFixed(2) + 's';
    c.style.top = '-64px';
    c.style.left = '0px';
    /* 水平定位写进 --tx（CSS 里 transform: translateX(var(--tx))）：
       is-hit / is-miss / 摆动动画改 transform 时才能带上它不跳位 */
    c.style.setProperty('--tx', tx + 'px');
    c.classList.add('is-falling');
    /* 下一帧移动到位（transition 生效的关键）；dur 秒落定收尾巴 */
    global.requestAnimationFrame(function () {
      c.style.top = (h - 64) + 'px';
      chip.x = tx;
      chip.y = h - 64;
    });
    /* 落定：触发一次落地压弹，压弹播完摘标记让位给脉冲动画 */
    global.setTimeout(function () {
      c.classList.remove('is-falling');
      c.classList.add('is-landed');
      global.setTimeout(function () { c.classList.remove('is-landed'); }, 420);
    }, dur * 1000 + 80);
  }

  function layoutChips() {
    /* 堆叠：已落定的 chip 在上方按 gap 排开，各自对准自己要落的键 */
    var top = -64;
    for (var i = 0; i < queue.length; i++) {
      var q = queue[i];
      q.el.style.left = '0px';
      q.el.style.top = top + 'px';
      q.el.style.setProperty('--tx', chipXFor(q.midi, q.el.offsetWidth || 64) + 'px');
      top -= (q.el.offsetHeight || 56) + q.gap;
    }
  }
  function dropAllChips() {
    while (queue.length) {
      var q = queue.pop();
      if (q.el && q.el.parentNode) { q.el.parentNode.removeChild(q.el); }
    }
  }
  /** 当前 chip 已被 promote 移出队列，不在 dropAllChips 的清单里——
   *  停止 / 结算 / 重开时要连它的 DOM 一起摘，否则正在落的星永远挂在画面上 */
  function dropChipEl() {
    if (chip && chip.el && chip.el.parentNode) { chip.el.parentNode.removeChild(chip.el); }
    chip = null;
  }
  /** 15 秒无进展给一句提醒（星星要的键亮起来） */
  function armHint() {
    if (hintTimer) { global.clearTimeout(hintTimer); }
    if (!running || mode !== 'practice' || !chip) { return; }
    hintTimer = global.setTimeout(function () {
      if (running && mode === 'practice' && chip) {
        flashKey(chip.midi, 'is-target');
        armHint();
      }
    }, 15000);
  }

  /* ---------------- demo 模式：按拍自动弹 ---------------- */
  function startDemo() {
    var beatMs = 60000 / song.bpm;
    var t = 400;
    song.notes.forEach(function (n, ni) {
      timers.push(global.setTimeout(function () {
        if (!running) { return; }
        A.ensure(function () { A.note(n[0], (n[1] * beatMs) / 1000); });
        flashKey(n[0], 'is-down');
        setText(E.status, '第 ' + (ni + 1) + ' / ' + song.notes.length
          + ' 个音：' + noteName(n[0]) + '（键盘 ' + keyOf(n[0]) + '）');
        sheetFollow(ni);
      }, t));
      t += n[1] * beatMs;
    });
    timers.push(global.setTimeout(function () { if (running) { finishDemo(); } }, t + 400));
    setText(E.status, '看星星落到线上，听它怎么走——听完点「练习」自己弹。');
  }
  function finishDemo() {
    running = false;
    clearTimers();
    restoreButtons();
    setText(E.status, '弹完了《' + song.name + '》。切到「练习」自己来一遍？');
  }

  /* ---------------- score 模式：跟谱练（动态电子谱，无声 + 可选节拍器） ----------------
   * 给对着真琴/电钢琴练的人：星星不掉、判定不出、琴声不响，只有谱面按 BPM 推进、
   * 当前音亮光环——屏幕就是一份会自己翻的乐谱。节拍器按拍独立调度（长音每拍都
   * 嗒，不跟音符起点走），每小节头一拍强。按琴键仍出声：想试音就按。 */
  function startScore() {
    var beatMs = 60000 / song.bpm;
    var t = 400;
    song.notes.forEach(function (n, ni) {
      timers.push(global.setTimeout(function () {
        if (!running) { return; }
        sheetFollow(ni);
        setText(E.status, '第 ' + (ni + 1) + ' / ' + song.notes.length + ' 个音：'
          + noteName(n[0]) + '（键盘 ' + keyOf(n[0]) + '）');
      }, t));
      t += n[1] * beatMs;
    });
    var metre = song.meter || 4;
    var total = 0;
    for (var i = 0; i < song.notes.length; i++) { total += song.notes[i][1]; }
    for (var b = 0; b < total; b++) {
      (function (bb) {
        timers.push(global.setTimeout(function () {
          if (running && metroOn) { A.tick(bb % metre === 0); }
        }, 400 + bb * beatMs));
      })(b);
    }
    timers.push(global.setTimeout(function () { if (running) { finishScore(); } }, t + 400));
    setText(E.status, metroOn
      ? '跟谱练：谱子按拍走，节拍器嗒嗒陪着——对着你的琴弹。'
      : '跟谱练：谱子按拍走、不出声——对着你的琴弹，想打拍子开「开始」旁的节拍器。');
  }
  function finishScore() {
    running = false;
    clearTimers();
    restoreButtons();
    setText(E.status, '《' + song.name + '》跟完了。再来一遍点「开始」，节奏跟不上就把节拍器打开慢练。');
  }
  function setMetro(on) {
    metroOn = !!on;
    syncMetro();
    savePref();
  }
  function syncMetro() {
    if (!E.metroBtns) { return; }
    for (var i = 0; i < E.metroBtns.length; i++) {
      var on = E.metroBtns[i].getAttribute('data-st-metro') === 'on';
      var match = (on === metroOn);
      E.metroBtns[i].classList.toggle('is-active', match);
      E.metroBtns[i].setAttribute('aria-pressed', match ? 'true' : 'false');
    }
  }

  /* ---------------- practice 结算 ---------------- */
  function finishPractice() {
    running = false;
    clearTimers();
    dropAllChips();
    dropChipEl();
    var total = song.notes.length;
    var hit = total - miss;
    var acc = hit / total;
    var stars = (acc >= 0.95 && miss === 0) ? 3 : (acc >= 0.8 ? 2 : 1);
    var line = '《' + song.name + '》弹完了：' + total + ' 个音按对 ' + hit + ' 个'
      + (miss > 0 ? '（跳过 ' + miss + ' 个）' : '，一个没跳') + '，最长连对 ' + bestCombo + '。';
    setText(E.resultText, line);
    renderStars(stars);
    celebrate(stars);
    showResult(true);
    saveBest(song.id, { stars: stars, score: score, combo: bestCombo, at: Date.now() });
    savePref();
    setText(E.status, '再来一遍点「开始」，换个曲子直接选。');
    setActions(false);
    restoreButtons();
  }
  function renderStars(n) {
    if (!E.resultStars) { return; }
    E.resultStars.textContent = '';
    for (var i = 0; i < 3; i++) {
      var s = icon('star');
      if (i >= n) { s.classList.add('is-dim'); }
      E.resultStars.appendChild(s);
    }
  }

  /* ---------------- free 模式 ---------------- */
  function setMode(next) {
    mode = next;
    savePref();
    if (E.modeBtns) {
      for (var i = 0; i < E.modeBtns.length; i++) {
        var on = E.modeBtns[i].getAttribute('data-st-mode') === mode;
        E.modeBtns[i].classList.toggle('is-active', on);
        E.modeBtns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }
    if (running) { stopRun(true); }
    /* 庆祝特效行只在跟着弹显示：命中爆闪（judge→burst）与三星结算（celebrate）
       都只在这模式触发，demo 纯播放、free 无判定、score 不打分，都无庆祝可看 */
    if (E.fxRow) { E.fxRow.hidden = mode !== 'practice'; }
    if (mode === 'free') {
      sheetClear();
      setFocus(false); /* 自由弹没有谱面，专注无意义 */
      setActions(true);
      setText(E.status, '自由弹：想按哪个按哪个，这里不打分也不出星星。');
      showResult(false);
    } else {
      setActions(false);
      /* 节拍器行只跟谱练显示（demo/practice 不需要打拍器，free 整行已收） */
      if (E.metroRow) { E.metroRow.hidden = mode !== 'score'; }
      sheetBuild();
      sheetFollow(0);
      idleStatus();
    }
  }
  function setActions(hide) {
    if (E.actions) { E.actions.hidden = !!hide; }
    /* fall-empty 文案教的是跟弹玩法：free 没有曲子跟着弹，一并收掉（与显隐矩阵 free 列「隐」一致） */
    if (E.fallEmpty) { E.fallEmpty.hidden = !!hide || mode === 'free'; }
  }
  /* 专注看谱：body 挂 st-focus-on，CSS 把谱面区铺满视口；自由弹无谱面不给进。
     退出路径只有两个：左上专注按钮（专注时显示「退出专注」，toggle）和 Esc。
     进出都按新容器尺寸重建谱面（逻辑坐标系随容器缩放），当前音接回原位。
     —— 显隐总览（显 = 页面流 / 浮 = 专注 fixed 浮层 / 盖 = 被全屏谱面盖住）——
     | 组件                 | demo     | practice | free     | score    | 专注(非free) |
     | st-actions 开始/停止 | 显       | 显       | 隐(整行) | 显       | 浮·左上      |
     | 「专注看谱」按钮     | 同上     | 同上     | 同上     | 同上     | 浮·左上(退出专注)|
     | 节拍器行             | 隐       | 隐       | 隐       | 显       | 浮·左下      |
     | 庆祝特效行           | 隐       | 显       | 隐       | 隐       | 盖(不可见)   |
     | 谱面/结算卡          | 显       | 显       | 隐       | 显       | 铺满视口     |
     | HUD/特效行/曲单等    | 显       | 显       | 显       | 显       | 盖(不可见)   |
     | fall-empty 提示      | 显       | 显       | 隐       | 显       | 盖(不可见)   |
     ---------------------------------------------------------------- */
  function setFocus(on) {
    var want = !!on && mode !== 'free';
    doc.body.classList.toggle('st-focus-on', want);
    if (E.focusBtn) { E.focusBtn.setAttribute('aria-pressed', want ? 'true' : 'false'); }
    if (E.focusLabel) { E.focusLabel.textContent = want ? '退出专注' : '专注看谱'; }
    if (E.focusIcon) { E.focusIcon.setAttribute('href', want ? '#i-minimize' : '#i-maximize'); }
    if (mode !== 'free' && sheet) {
      sheetBuild();
      sheetFollow(sheetCur || 0);
    }
  }

  /* ---------------- 开始 / 停止 ---------------- */
  function startRun() {
    if (running) { return; }
    A.ensure(function () {
      running = true;
      idx = 0; score = 0; combo = 0; bestCombo = 0; miss = 0; wrongStreak = 0;
      updateHud();
      showResult(false);
      syncKeys();
      dropAllChips();
      dropChipEl();
      sheetBuild();
      sheetFollow(0);
      setActions(false);
      if (E.startBtn) { E.startBtn.disabled = true; }
      if (E.stopBtn) { E.stopBtn.disabled = false; }
      if (fxEnabled()) { ensureConfetti(null); } /* 预热：星星落地前把 vendor 脚本拉好 */
      if (mode === 'demo') { startDemo(); }
      else if (mode === 'practice') { setText(E.status, '准备……'); spawnNext(); }
      else if (mode === 'score') { startScore(); }
    });
  }
  /** 回到待机态：开始可点、停止收回（自然弹完与手动停止共用） */
  function restoreButtons() {
    if (E.startBtn) { E.startBtn.disabled = false; }
    if (E.stopBtn) { E.stopBtn.disabled = true; }
  }
  function stopRun(silent) {
    running = false;
    clearTimers();
    dropAllChips();
    dropChipEl();
    sheetClear();
    /* 停止后谱面回到待练状态：此前只清不建，掉落区留白（专注全屏时是一块空板） */
    if (mode !== 'free' && song.notes && song.notes.length) {
      sheetBuild();
      sheetFollow(0);
    }
    syncKeys();
    restoreButtons();
    if (!silent) { setText(E.status, '已停止。点「开始」重新来。'); }
  }
  function clearTimers() {
    for (var i = 0; i < timers.length; i++) { global.clearTimeout(timers[i]); }
    timers = [];
    if (hintTimer) { global.clearTimeout(hintTimer); hintTimer = null; }
    if (demoRAF) { global.cancelAnimationFrame(demoRAF); demoRAF = null; }
  }
  function showResult(show) {
    if (E.result) { E.result.hidden = !show; }
  }

  /* ---------------- 庆祝特效（canvas-confetti 懒注入 + 三档偏好） ----------------
   * 「关 / 星星 / 纸屑」三档存本机；星星/纸屑走 vendor 的 canvas-confetti（懒注入，
   * 无真 canvas（jsdom 等）永不注入），关档或系统减动效走内置轻粒子；vendor 尚未
   * 就绪的第一次命中用内置粒子兜底，就绪后自动升级。 */
  var RM = false;
  try { RM = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* 保持 false */ }
  var FX_STYLES = ['off', 'star', 'note', 'confetti'];
  var FX_COLORS_STARS = ['#f7c948', '#ffd76e', '#fff1b8', '#ffffff'];
  var FX_COLORS_NOTE = ['#dc2626', '#ea580c', '#eab308', '#16a34a', '#0e7490', '#2563eb', '#7c3aed'];
  var FX_COLORS_CONF = ['#f7c948', '#7c6cf6', '#4cb944', '#ff7a59', '#63b3ed', '#ffffff'];
  var noteShapesCache;  /* undefined=没测过，null=vendor 不支持，数组=可用 */
  function noteShapes() {
    if (noteShapesCache !== undefined) { return noteShapesCache; }
    noteShapesCache = null;
    try {
      if (typeof global.confetti !== 'undefined' && typeof global.confetti.shapeFromText === 'function') {
        noteShapesCache = [global.confetti.shapeFromText({ text: '♪' }), global.confetti.shapeFromText({ text: '♫' })];
      }
    } catch (e) { noteShapesCache = null; }
    return noteShapesCache;
  }
  var fx = 'star';
  var confettiReady = false;
  var confettiPending = false;
  function fxEnabled() { return !RM && fx !== 'off'; }
  var CANVAS_OK = null;
  function canvasOk() {
    /* 只探测一次并记住（jsdom 等环境反复探测会反复触发宿主告警） */
    if (CANVAS_OK === null) {
      try {
        var t = doc.createElement('canvas');
        CANVAS_OK = !!(t.getContext && t.getContext('2d'));
      } catch (e) { CANVAS_OK = false; }
    }
    return CANVAS_OK;
  }
  function ensureConfetti(done) {
    if (confettiReady) { if (done) { done(true); } return; }
    if (!canvasOk() || confettiPending) { return; }
    confettiPending = true;
    var s = doc.createElement('script');
    s.src = '/static/study/vendor/confetti.browser.min.js?v=' + (root.getAttribute('data-st-ver') || '');
    s.async = true;
    s.onload = function () {
      confettiPending = false;
      confettiReady = typeof global.confetti === 'function';
      if (confettiReady && done) { done(true); }
    };
    s.onerror = function () { confettiPending = false; /* 下次命中可重试 */ };
    doc.head.appendChild(s);
  }
  function originOf(x) {
    var rect = E.fallWrap.getBoundingClientRect();
    var vw = global.innerWidth || doc.documentElement.clientWidth || 1;
    var vh = global.innerHeight || doc.documentElement.clientHeight || 1;
    return {
      x: Math.min(1, Math.max(0, (rect.left + x + 32) / vw)),
      y: Math.min(1, Math.max(0, (rect.top + E.fallWrap.clientHeight - 40) / vh))
    };
  }
  function fireConfetti(opts) {
    try { opts.disableForReducedMotion = true; global.confetti(opts); return true; } catch (e) { return false; }
  }
  function hitConfetti(x) {
    var origin = originOf(x);
    if (fx === 'star') {
      /* 星星档：命中线上炸一小簇金星星 */
      fireConfetti({ particleCount: 12, spread: 60, startVelocity: 24, gravity: .9, decay: .92,
        scalar: .8, ticks: 110, shapes: ['star'], colors: FX_COLORS_STARS, origin: origin });
    } else if (fx === 'note') {
      /* 音符档：命中处炸一小簇彩虹音符（旧 vendor 没有 shapeFromText 就用默认形状） */
      var o = { particleCount: 14, spread: 65, startVelocity: 26, gravity: .8, decay: .92,
        scalar: 1.2, ticks: 120, colors: FX_COLORS_NOTE, origin: origin };
      var ns = noteShapes();
      if (ns) { o.shapes = ns; }
      fireConfetti(o);
    } else {
      /* 纸屑档：多彩小纸屑 */
      fireConfetti({ particleCount: 26, spread: 70, startVelocity: 28, scalar: .9, ticks: 130,
        colors: FX_COLORS_CONF, origin: origin });
    }
  }
  function legacyBurst(x) {
    if (RM || !E.fallWrap) { return; }
    for (var i = 0; i < 7; i++) {
      (function (i) {
        var p = el('span', 'st-burst' + (i % 3 === 2 ? ' st-burst--w' : ''));
        p.style.left = x + 32 + 'px';
        p.style.top = (E.fallWrap.clientHeight - 40) + 'px';
        p.style.setProperty('--dx', ((i - 3) * 18 + (i % 2 ? 8 : -8)) + 'px');
        p.style.setProperty('--dy', (-30 - i * 9) + 'px');
        E.fallWrap.appendChild(p);
        global.setTimeout(function () {
          if (p.parentNode) { p.parentNode.removeChild(p); }
        }, 620);
      })(i);
    }
  }
  function burst(x) {
    if (!E.fallWrap) { return; }
    if (!fxEnabled()) { legacyBurst(x); return; }
    if (confettiReady) { hitConfetti(x); return; }
    ensureConfetti(null);
    legacyBurst(x); /* vendor 还在加载的第一次：内置粒子兜底，下一发起升级 */
  }
  /* 弹完 3 星的庆祝：星星档左右两炮金星星、音符档中央彩色音符雨、纸屑档中央大
   * 爆发（RM/关档安静收尾） */
  function celebrate(stars) {
    if (stars < 3 || !fxEnabled() || !E.fallWrap) { return; }
    ensureConfetti(function () {
      if (fx === 'star') {
        var base = { particleCount: 22, spread: 60, startVelocity: 42, gravity: .9, scalar: .9,
          ticks: 170, shapes: ['star'], colors: FX_COLORS_STARS };
        fireConfetti(Object.assign({}, base, { angle: 60, origin: { x: 0, y: .75 } }));
        fireConfetti(Object.assign({}, base, { angle: 120, origin: { x: 1, y: .75 } }));
      } else if (fx === 'note') {
        var o = { particleCount: 80, spread: 100, startVelocity: 45, scalar: 1.3, ticks: 200,
          colors: FX_COLORS_NOTE, origin: { y: .6 } };
        var ns = noteShapes();
        if (ns) { o.shapes = ns; }
        fireConfetti(o);
      } else {
        fireConfetti({ particleCount: 90, spread: 100, startVelocity: 45, scalar: .9, ticks: 200,
          colors: FX_COLORS_CONF, origin: { y: .6 } });
      }
    });
  }
  function setFx(next) {
    if (FX_STYLES.indexOf(next) < 0) { next = 'star'; }
    fx = next;
    syncFx();
    savePref();
    if (fxEnabled()) { ensureConfetti(null); } /* 切到开档就预热 vendor */
  }
  function syncFx() {
    if (!E.fxBtns) { return; }
    for (var i = 0; i < E.fxBtns.length; i++) {
      var on = E.fxBtns[i].getAttribute('data-st-fx') === fx;
      E.fxBtns[i].classList.toggle('is-active', on);
      E.fxBtns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  /* ---------------- 接线与启动 ---------------- */
  function cacheDom() {
    E.songsBox = root.querySelector('[data-st-songs]');
    E.modeBtns = root.querySelectorAll('[data-st-mode]');
    E.fallWrap = root.querySelector('[data-st-fall]');
    E.fallEmpty = root.querySelector('[data-st-fall-empty]');
    E.keys = root.querySelector('[data-st-keys]');
    E.status = root.querySelector('[data-st-status]');
    E.startBtn = root.querySelector('[data-st-start]');
    E.startLabel = root.querySelector('[data-st-start-label]');
    E.stopBtn = root.querySelector('[data-st-stop]');
    E.result = root.querySelector('[data-st-result]');
    E.resultStars = root.querySelector('[data-st-result-stars]');
    E.resultText = root.querySelector('[data-st-result-text]');
    E.best = root.querySelector('[data-st-best]');
    E.actions = root.querySelector('[data-st-actions]');
    E.hudScore = root.querySelector('[data-st-hud-score]');
    E.hudCombo = root.querySelector('[data-st-hud-combo]');
    E.fxBtns = root.querySelectorAll('[data-st-fx]');
    E.fxRow = root.querySelector('[data-st-fx-row]');
    E.metroRow = root.querySelector('[data-st-metro-row]');
    E.metroBtns = root.querySelectorAll('[data-st-metro]');
    E.customPanel = root.querySelector('[data-st-custom]');
    E.customText = root.querySelector('[data-st-custom-text]');
    E.customBpm = root.querySelector('[data-st-custom-bpm]');
    E.customMeter = root.querySelector('[data-st-custom-meter]');
    E.customSave = root.querySelector('[data-st-custom-save]');
    E.customErr = root.querySelector('[data-st-custom-err]');
    E.customImport = root.querySelector('[data-st-custom-import]');
    E.customFile = root.querySelector('[data-st-custom-file]');
    E.osmdToggle = root.querySelector('[data-st-osmd-toggle]');
    E.osmd = root.querySelector('[data-st-osmd]');
    E.osmdTip = root.querySelector('.st-osmd-tip');
    E.osmdZoomBox = root.querySelector('[data-st-osmd-zoom]');
    E.osmdZoomVal = root.querySelector('[data-st-osmd-zoom-val]');
    E.focusBtn = root.querySelector('[data-st-focus]');
    E.focusLabel = root.querySelector('[data-st-focus-label]');
    E.focusIcon = root.querySelector('[data-st-focus-icon]');
    E.focusProg = root.querySelector('[data-st-focus-prog]');
  }
  function bindEvents() {
    if (E.startBtn) {
      E.startBtn.addEventListener('click', function () { startRun(); });
    }
    if (E.stopBtn) {
      E.stopBtn.addEventListener('click', function () { stopRun(false); });
    }
    if (E.modeBtns) {
      for (var i = 0; i < E.modeBtns.length; i++) {
        (function (b) {
          b.addEventListener('click', function () { setMode(b.getAttribute('data-st-mode')); });
        })(E.modeBtns[i]);
      }
    }
    if (E.fxBtns) {
      for (var j = 0; j < E.fxBtns.length; j++) {
        (function (b) {
          b.addEventListener('click', function () { setFx(b.getAttribute('data-st-fx')); });
        })(E.fxBtns[j]);
      }
    }
    if (E.metroBtns) {
      for (var k = 0; k < E.metroBtns.length; k++) {
        (function (b) {
          b.addEventListener('click', function () { setMetro(b.getAttribute('data-st-metro') === 'on'); });
        })(E.metroBtns[k]);
      }
    }
    if (E.customSave) {
      E.customSave.addEventListener('click', function () { saveCustom(); });
    }
    if (E.customImport && E.customFile) {
      E.customImport.addEventListener('click', function () { E.customFile.click(); });
      E.customFile.addEventListener('change', function () {
        var f = E.customFile.files && E.customFile.files[0];
        E.customFile.value = ''; /* 先清掉，允许重复导入同一个文件 */
        if (!f) { return; }
        var fr = new global.FileReader();
        fr.onload = function () { importMusicXml(String(fr.result || '')); };
        fr.onerror = function () { showCustomErr('文件读不出来——换一个标准的 .xml/.musicxml 试试'); };
        try { fr.readAsText(f); } catch (e) { showCustomErr('文件读不出来——换一个标准的 .xml/.musicxml 试试'); }
      });
    }
    /* 出版谱：展开/收起 + 缩放（渲染后的 SVG 由 OSMD 自管，这里只调 zoom 重渲） */
    if (E.osmdToggle) {
      E.osmdToggle.addEventListener('click', function () {
        if (E.osmd && E.osmd.hidden) { openOsmd(); } else { closeOsmd(); }
      });
    }
    if (E.osmdZoomBox) {
      var zbtns = E.osmdZoomBox.querySelectorAll('[data-st-osmd-zoom-btn]');
      for (var zi = 0; zi < zbtns.length; zi++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            setOsmdZoom(btn.getAttribute('data-st-osmd-zoom-btn') === '+' ? 0.1 : -0.1);
          });
        })(zbtns[zi]);
      }
    }
    if (E.focusBtn) {
      E.focusBtn.addEventListener('click', function () { setFocus(!doc.body.classList.contains('st-focus-on')); });
    }
    /* 窗口尺寸变化：谱面 viewBox 依赖容器宽高比（等比拉伸），防抖 200ms 后重建，
       当前音接回原位；星星是像素层不受影响。jsdom 不触发 resize，零感知。 */
    var rsTimer = null;
    global.addEventListener('resize', function () {
      if (rsTimer) { global.clearTimeout(rsTimer); }
      rsTimer = global.setTimeout(function () {
        rsTimer = null;
        sheetBuild();
        if (sheet && sheet.notes[idx]) { sheetFollow(idx); }
      }, 200);
    });
    if (E.keys) {
      /* 琴键主通道用 pointerdown：按下即响（click 要等手指抬起才触发，弹琴不跟手）；
         preventDefault 挡掉后续合成 click 防双音，顺带免点按抢焦点。
         键盘激活（Tab 聚焦 + Enter/Space）走的 click 无指针序列（detail===0），
         由下方 click 通道接管——两条路互不重复。 */
      var keyFromEvent = function (ev) {
        var t = ev.target;
        while (t && t !== E.keys && !t.getAttribute) { t = t.parentNode; }
        return t && t.closest ? t.closest('[data-pk]') : null;
      };
      E.keys.addEventListener('pointerdown', function (ev) {
        if (ev.button !== undefined && ev.button !== 0) { return; } /* 右键/中键不弹 */
        var k = keyFromEvent(ev);
        if (!k) { return; }
        ev.preventDefault();
        pressNote(parseInt(k.getAttribute('data-pk'), 10));
      });
      E.keys.addEventListener('click', function (ev) {
        if (ev.detail !== 0) { return; } /* 指针合成的 click 已由 pointerdown 处理 */
        var k = keyFromEvent(ev);
        if (k) { pressNote(parseInt(k.getAttribute('data-pk'), 10)); }
      });
    }
    doc.addEventListener('keydown', function (ev) {
      if (ev.repeat || ev.ctrlKey || ev.metaKey || ev.altKey) { return; }
      var tag = (ev.target && ev.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') { return; }
      if (ev.key === 'Escape') { setFocus(false); return; } /* 专注模式下 Esc 退出 */
      var k = (ev.key || '').toUpperCase();
      if (k.length !== 1) { return; }
      for (var m = 60; m <= 84; m++) {
        if (KEY_OF[m] === k) { pressNote(m); ev.preventDefault(); return; }
      }
    });
  }
  function restore() {
    var pref = loadPref();
    if (pref && pref.song) { pickSong(pref.song); }
    if (pref && pref.mode) { setMode(pref.mode); }
    if (pref && pref.fx) { setFx(pref.fx); }
    if (pref && typeof pref.metro === 'boolean') { setMetro(pref.metro); }
  }
  /* smoke/调试钩子：出版谱 XML 生成器只读暴露（纯函数无状态，供冒烟断言小节切分/tie/附点） */
  global.__gqScoreXml = { buildMusicXml: buildMusicXml, xmlSpell: xmlSpell, xmlNoteType: xmlNoteType, osmdStripBreaks: osmdStripBreaks };
  function boot() {
    if (!root) { return; }
    cacheDom();
    /* 我的谱子：先从本机恢复（曲对象 + 编辑面板回填），restore 恢复偏好时选曲才找得到 */
    var raw = loadCustomRaw();
    customSong = customSongOf(raw);
    if (raw && E.customText) {
      E.customText.value = raw.text;
      if (E.customBpm) { E.customBpm.value = raw.bpm >= 40 && raw.bpm <= 200 ? raw.bpm : 80; }
      if (E.customMeter) { E.customMeter.value = raw.meter === 3 ? '3' : '4'; }
    }
    renderSongs();
    syncCustomBtn();
    renderKeys();
    bindEvents();
    restore();
    if (mode !== 'free') { sheetBuild(); sheetFollow(0); }
    renderBest();
    idleStatus();
    if (E.stopBtn) { E.stopBtn.disabled = true; }
  }
  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
